import { MessageDescriptor } from 'react-intl';
import { commonErrorMessages } from '../../../../messages';
import offeringDocumentsMessages from '../../../../messages/documents-area/offering-documents.messages';
import {
  OfferingCompanies,
  OfferingDocumentType,
} from '../../../../model/documents/offering-document';
import { OfferingDocumentGroupType } from '../../../../model/documents/offering-document-group';
import { ErrorMessages } from '../../../../model/error';
import { OfferingDocumentsError } from './offerings-types';

export const messagesForOfferingDocumentsError = (
  error: OfferingDocumentsError
): ErrorMessages => {
  switch (error) {
    case 'GENERIC_ERROR':
    default:
      return {
        title: commonErrorMessages.errorTitleDefault,
        description: commonErrorMessages.errorDescriptionDefault,
      };
  }
};

export const labelForOfferingDocumentsCompany = (
  company: OfferingCompanies
): MessageDescriptor => {
  switch (company) {
    case 'ALLFUNDSBANK':
      return offeringDocumentsMessages.allFundsCompanyType;
    case 'Azimut':
      return offeringDocumentsMessages.azimutCompanyType;
    default:
      return {
        id: company,
        defaultMessage: company,
      };
  }
};

export const labelForOfferingDocumentsType = (
  type?: OfferingDocumentType
): MessageDescriptor => {
  switch (type) {
    case 'KIID':
      return offeringDocumentsMessages.kiidDocumentType;
    case 'Letter':
      return offeringDocumentsMessages.letterDocumentType;
    default:
      return {
        id: type || '',
        defaultMessage: type || '',
      };
  }
};

export const labelForOfferingDocumentGroups = (
  type: OfferingDocumentGroupType
): MessageDescriptor => {
  switch (type) {
    case 'AllFunds':
      return offeringDocumentsMessages.allFunds;
    case 'Azimut':
      return offeringDocumentsMessages.azimut;
    default:
      return {
        id: type,
        defaultMessage: type,
      };
  }
};
